import { z } from 'zod';
import { buyerSalesContextSchema } from './sales-psychology';
import { propertySearchSchema } from './catalog';
import { catalogConversationSetSchema } from './catalog-results';
import { sourceFactSchema, timestampSchema } from './assistant';
import { uuidV7Schema } from './ids';

export const configurationPreviewMessageSchema = z
  .object({
    id: uuidV7Schema,
    role: z.enum(['customer', 'assistant']),
    text: z.string().min(1).max(16_000),
    occurredAt: timestampSchema,
  })
  .strict();

export const configurationPreviewOfferSchema = z
  .object({
    kind: z.enum(['calendar_availability', 'find_appointment_slots']),
    status: z.string().min(1).max(50),
    facts: z.array(sourceFactSchema).max(10),
  })
  .strict();

export const configurationPreviewStateSchema = z
  .object({
    channel: z.enum(['chat', 'email']),
    history: z.array(configurationPreviewMessageSchema).max(20),
    buyer: buyerSalesContextSchema,
    offers: z.array(configurationPreviewOfferSchema).max(10),
    currentPropertySearch: propertySearchSchema.nullable(),
    comparisonFacts: z.array(sourceFactSchema).max(180).default([]),
    catalogSets: z.array(catalogConversationSetSchema).max(6).default([]),
  })
  .strict();

export type ConfigurationPreviewState = z.infer<
  typeof configurationPreviewStateSchema
>;
